import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SourcingEventStatus } from "../../../autogen/bff-api";

interface Props {
  status: SourcingEventStatus;
}

export const PublicationStatusBanner = ({ status }: Props) => {
  const { t } = useTranslation();

  if (status === SourcingEventStatus.PublicationPending) {
    return (
      <Box mt="4">
        <Alert status="info" rounded="md" fontSize="sm" alignItems="flex-start">
          <AlertIcon />
          <Box>
            <AlertTitle>{t("Sent to Doffin – awaiting publication")}</AlertTitle>
            <AlertDescription>
              {t(
                "Your notice will be published as soon as Doffin has processed it. There's nothing you need to do — this page updates automatically once it's live.",
              )}
            </AlertDescription>
          </Box>
        </Alert>
      </Box>
    );
  }

  if (status === SourcingEventStatus.PublicationFailed) {
    return (
      <Box mt="4">
        <Alert status="error" rounded="md" fontSize="sm" alignItems="flex-start">
          <AlertIcon />
          <Box>
            <AlertTitle>{t("Publication to Doffin failed")}</AlertTitle>
            <AlertDescription>
              {t(
                "Something went wrong while publishing this notice to Doffin. This is rare — please contact support and we'll help you get it published.",
              )}
            </AlertDescription>
          </Box>
        </Alert>
      </Box>
    );
  }

  return null;
};
